export const NAMESPACE = 'ratzgiwatz-anmeldung';
export const DATE_FORMAT = 'DD.MM.YYYY';
export const TIMEOUT_XML_HTTP_REQUESTS_MILLIS = 30000;
export const BEITRAG_ERSTES_KIND = 87;
export const BEITRAG_GEWSCHISTERKINDER = 67;



// WEBPACK FOOTER //
// ./src/constants.js